export default __webpack_public_path__ + "static/media/yellow-sport-car-slider2.51e7b707.jpg";